module.exports = __webpack_public_path__ + "static/img/about4.81e11e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/about4.png
// module id = MIzO
// module chunks = 1